import { render, staticRenderFns } from "./RupturasResumo.vue?vue&type=template&id=2c65279d&scoped=true"
import script from "./RupturasResumo.vue?vue&type=script&lang=js"
export * from "./RupturasResumo.vue?vue&type=script&lang=js"
import style0 from "./RupturasResumo.vue?vue&type=style&index=0&id=2c65279d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c65279d",
  null
  
)

export default component.exports